const firebaseConfig = {
  apiKey: "AIzaSyB3zcVKb6WbJsugOoMJYBE2GeTS6DHU3nU",
  authDomain: "flying-fridge.firebaseapp.com",
  projectId: "flying-fridge",
  storageBucket: "flying-fridge.appspot.com",
  messagingSenderId: "709977221159",
  appId: "1:709977221159:web:0add6557e6d9b9cf3a8602"
};

module.exports = firebaseConfig
// export default firebaseConfig;